import styled from "styled-components";
import TabComponent from "../common/tabComponent";
import { tabMenu } from "../../types/types";
import { useEffect, useState } from "react";
import { companyContractDto } from "../../types/data";
import { useParams } from "react-router-dom";
import API from "../../API/API";
import { getCompanyContractDetail } from "../../API/AppRepository";
import path from "path";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const TabComponentBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2vw;
  width: 94vw;
  height: 100%;
`;

const tabMenuList: tabMenu[] = [
  { id: 0, title: "1. 기본 정보" },
  { id: 1, title: "2. 물품 정보" },
  { id: 2, title: "3. 산출내역서" },
];

export default function CreateEnterpriseComponent() {
  const params = useParams();
  const cmCd = params.id;
  const [contractInfo, setContractInfo] = useState(companyContractDto);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [maxIndex, setMaxIndex] = useState<number>(1);
  const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");
  // 디테일 페이지 여부 확인
  const isDetailPage = Boolean(cmCd);

  // 디테일 모드일 경우 데이터 불러오기
  useEffect(() => {
    const fetchData = async () => {
      if (isDetailPage) {
        // 서버에서 상세 데이터 가져오기
        if (cmCd) {
          const result = await getCompanyContractDetail(cmCd); // await 사용
          const chargeListLength = result.chargeList.length;
          setMaxIndex(chargeListLength);
          setContractInfo(result);
        }
      } else {
        // 새로운 견적서 생성 시 기본값 설정
        setContractInfo((prev: any) => {
          const updatedData = { ...prev };
          updatedData.contractInfo.headInfo.contactPerson = loginUser.name;
          updatedData.contractInfo.headInfo.contactNumber = loginUser.contact;
          // updatedData.contractInfo.headInfo.email = loginUser.email;
          return updatedData;
        });
      }
    };

    fetchData(); // 비동기 함수 호출
  }, [isDetailPage, cmCd]);

  // useEffect(() => {
  //   setContractInfo((prev: any) => {
  //     const updatedData = { ...prev };
  //     updatedData.contractInfo.headInfo.contactPerson = loginUser.name;
  //     updatedData.contractInfo.headInfo.contactNumber = loginUser.contact;
  //     // updatedData.contractInfo.headInfo.email = loginUser.email;
  //     // TODO : email 추가되면 이메일도 가져와 넣기

  //     return updatedData;
  //   });
  // }, []);

  const onChangeInput = (e: any) => {
    const { name, value } = e.target;

    if (!name) {
      return;
    }
    const paths = name.split(".");

    setContractInfo((prev: any) => {
      const updatedData = { ...prev };
      // name 속성의 각 계층을 따라 들어가면서 최종 필드 값 없데이트
      let current = updatedData;
      for (let i = 1; i < paths.length - 1; i++) {
        current = current[paths[i]];
      }

      current[paths[paths.length - 1]] = value;

      return updatedData;
    });
  };

  return (
    <Wrapper>
      <TabComponentBox>
        <TabComponent
          isDetailPage={isDetailPage}
          tabMenuList={tabMenuList}
          data={contractInfo}
          setData={setContractInfo}
          onChangeInput={onChangeInput}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          maxIndex={maxIndex}
          setMaxIndex={setMaxIndex}
        ></TabComponent>
      </TabComponentBox>
    </Wrapper>
  );
}
